<template>
  <div class="Page">
    <div class="Page-Content" style="overflow: hidden;">
      <iframe style="width: calc(100% - 55px);height: 100%;padding: 0;margin: 0;margin-right: 55px;" src="./siteplan.html" frameborder="0"></iframe>
    </div>
    <!-- <img style="height: 100%;" src="@/assets/media/facilities.png" alt=""> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  methods:{

  },
  mounted(){

  },
}
</script>

<style lang="less">
  
</style>

